import { defineStore } from 'pinia';
import { getCurrentUser } from '@/api/subscription';
export const useSubscriberStore = defineStore('subscriber', {
    state: () => ({
        lastName: '',
        firstName: '',
        phone: '',
        function: '',
        company: '',
        hectares: '',
        type: '',
        wilaya: 0,
        commune: 0,
        cultures: [],
        rules: false, 
        token: null,
    }),
    actions: {
        async loadUserFromToken() {
            const token = localStorage.getItem('auth_token')
            if (!token) return false;

            try {
                this.token = token

                const { data } = await getCurrentUser();

                this.lastName = data.user.last_name
                this.firstName = data.user.first_name
                this.phone = data.user.phone
                this.function = data.subscription.function
                this.company = data.subscription.company
                this.hectares = data.subscription.nbr_hectars
                this.type = data.user.type
                this.wilaya = data.subscription.wilaya
                this.commune = data.subscription.commune
                this.cultures = data.subscription.cultures

            } catch (error) {
                console.error('Failed to load user from token:', error)
                localStorage.removeItem('auth_token')
                this.token = null

                return false;
            }


            return true;
        },
        setSubscriberData(data) {
            this.$patch(data);
        },
        reset() {
            this.$reset();
        },
        setAuthData({ token, user, subscription }) {
          
            this.firstName = user.first_name;
            this.lastName = user.last_name;
            this.phone = user.phone;
            this.type = user.type;
            this.function = subscription.function;
            this.company = subscription.company;
            this.hectares = subscription.nbr_hectars;
            this.wilaya = subscription.wilaya;
            this.commune = subscription.commune;
            this.cultures = subscription.cultures;
            this.token = token;
            localStorage.setItem('auth_token', token);
        },
        setFormData({ user }) {

            this.firstName = user.firstName;
            this.lastName = user.lastName;
            this.phone = user.phone;
            this.type = user.type;
            this.function = user.function;
            this.company = user.company;
            this.hectares = user.hectares;
            this.wilaya = user.wilaya;
            this.commune = user.commune;
            this.cultures = user.cultures;
        },
        loadAuthData() {
            const token = localStorage.getItem('auth_token');
            if (token) this.token = token;
        },
        clearAuthData() {
            this.token = null;
            this.user = null;
            this.subscription = null;
            localStorage.removeItem('auth_token');
        }
    },
    getters: {
        isFilled: (state) => !!state.firstName && !!state.lastName
    }
});
